<template>
  <div>
    <vs-table
      v-if="show"
      :params="params"
      :options="options"
      @onCreateHeaderActionClicked="selectDocumentType"
    ></vs-table>

    <b-modal
      ref="selectDocumentTypeModal"
      title="انتخاب نوع سند انبار"
      size="sm"
      ok-title="سند ورود کالا به انبار"
      @ok="enterSelected"
      cancel-title="سند خروج کالا از انبار"
      @cancel="exitSelected"
    >

    </b-modal>
  </div>

</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import BdInput from "../components/BDInput";
  import MiladiToShamsi from "../components/MiladiToShamsi";
  import BaseService from "../_framework/api/BaseService.js";

  export default {
    name: "documents",
    created: () => {
    },
    components: {
      VsTable,
      MiladiToShamsi
    },
    data() {
      return {
        show: true,
        access: {},
        params: {
          entity: "voucher",
          list: [],
          headers: {
            // voucherNumber: {
            //   title: "شماره",
            //   type: "text",
            //   rowAlignment: "center"
            // },
            voucherDate: {
              title: "تاریخ",
              type: "custom",
              component: MiladiToShamsi,
              formatGregorianDateToJalaali: true,
              rowAlignment: "center"
            },
            serveName: {
              title: "تحویل دهنده",
              type: "text",
              rowAlignment: "center"
            },
            receiverName: {
              title: "تحویل گیرنده",
              type: "text",
              rowAlignment: "center"
            },
            orderCode: {
              title: "کد سفارش",
              type: "text",
              rowAlignment: "center"
            },
            documentType: {
              title: "نوع حواله",
              type: "custom",
              component: BdInput,
              rowAlignment: "center"
            }
          }
        },
        options: {
          hasActions: true,
          hasActionsInHeader: true,
          clickableRows: true,
          isPrintable:true,
          onCreateHeaderActionClicked: true,
          onEditClicked: (row, context) => {
            if (
              row.serveCompanyId &&
              row.serveCompanyId !== localStorage.getItem("companyId") * 1
            ) {
              this.$noty.error("امکان ویرایش سند وجود ندارد");
              return;
            }
            this.openVoucher("edit", row.id);
          },
          onPrintClicked: (row, context) => {
            this.goToPrintPage(row);
          },
          beforeDeleteEntity: input => {
            if (
              input.serveCompanyId &&
              input.serveCompanyId !== localStorage.getItem("companyId") * 1
            ) {
              this.$noty.error("امکان حذف سند وجود ندارد");
              return;
            }
            return input;
          },
          onRowDoubleClicked: row => {
            this.openVoucher("view", row.id);
          },
          // getTopRightButtons: () => {
          //   let arr = [];
          //   let searchToggleButton = {
          //     component: "search-toggle-button"
          //   };
          //   arr.push(searchToggleButton);
          //   return arr;
          // },
          getTopLeftButtons: () => {
            let arr = [];
            let self = this;
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {
                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            arr.push(addItemButton);
            return arr;
          }
        }
      };
    },
    methods: {
      goToPrintPage(row) {
        this.$router.push(
          {
            name: "پرینت ووچر",
            params: {
              id: row.id
            }
          }
        );
      },
      selectDocumentType() {
        this.$refs.selectDocumentTypeModal.show();

      },
      enterSelected() {
        this.$refs.selectDocumentTypeModal.hide();
        const data = {
          _docType: "enter"
        };
        this.createVoucher('create', data);
      },
      exitSelected() {
        const data = {
          _docType: "exit"
        };
        this.createVoucher('create', data);
      },
      createVoucher(_mode, _data) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
        this.$router.push({
          path: "/voucher",
          query: {_mode, _data}
        });
      },
      openVoucher(_mode, id) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
        this.$router.push({
          path: "/voucher",
          query: {id, _mode}
        });
      }
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      // console.log(this.options.access);
      this.show = this.options.access ? true : false;
    }
  };
</script>
